import { FileInfo } from '@cognite/sdk';

const CACHE_VERSION_KEY = 'v1';

/**
 * Generates a cache key for a given file based on its ID and last updated time.
 * NB! The same file can map to different binary data returned from different endpoints.
 * (e.g. preview, download). Caller must take care to not reuse the same cache key for different
 * binary data.
 * @param file - The file information object.
 * @returns A string representing the cache key.
 *
 */
const getFileDataCacheKey = (file: FileInfo): string =>
  `${CACHE_VERSION_KEY}-${file.id}-${
    file.lastUpdatedTime instanceof Date
      ? file.lastUpdatedTime.getTime()
      : file.lastUpdatedTime
  }`;

export default getFileDataCacheKey;
